<!-- 试卷-题目列表 -->
<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>学术系统</el-breadcrumb-item>
      <el-breadcrumb-item>试卷管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-page-header @back="goBack"></el-page-header>
    <el-card style="margin-top: 15px">
      <div class="title title_class">{{ typeStr }}</div>
      <el-row class="title_row" align="middle" type="flex">
        <el-col :span="12">
          <span><span class="formName">{{ formName }}</span> 试题详情<i class="refresh el-icon-refresh" @click="getList()"></i></span>
        </el-col>
        <!-- <el-col :span="12" style="text-align: right;">
          <el-button type="primary" @click="showDialog(null)"
            >新建试卷</el-button
          >
        </el-col> -->
      </el-row>
      <el-table
        header-cell-class-name="tableHeaderStyle"
        :data="dataList"
        border
        :row-class-name="rowClass"
      >
        <el-table-column label="题型" prop="typeName" width="130px">
          <template slot-scope="scope">
            {{ scope.row.typeName }}<br/>{{ scope.row.typeEngName }}
          </template>
        </el-table-column>
        <el-table-column label="Pinyin" prop="pinYin" width="90" align="center">
          <template slot-scope="scope">
            <span class="bid-font">{{ scope.row.pinYin }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Meaning" prop="meaning">
          <template slot-scope="scope">
            <span class="bid-font">{{ scope.row.meaning }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Sentence" prop="sentence" width="212">
          <template slot-scope="scope">
            <span class="bid-font">{{ scope.row.sentence }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Part of Speech" prop="partOfSpeech">
          <template slot-scope="scope">
            <span class="bid-font">{{ scope.row.partOfSpeech }}</span>
          </template>
        </el-table-column>
        <el-table-column label="小题序号" prop="quizNumber" width="80px">
          <template slot-scope="scope">
            <div style="display: flex; align-items: center;">
              {{ scope.row.quizNumber }}
              <el-tag v-if="scope.row.isStandby" type="warning" size="mini" style="margin-left: 4px;">备用</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Character" prop="word">
          <template slot-scope="scope">
            <span class="bid-font">{{ scope.row.word }}</span>
          </template>
        </el-table-column>
        <el-table-column label="答案" prop="answer" width="80px">
          <template slot-scope="scope">
            <div style="display: flex; align-items: center;">
              <div v-for="(a, aIndex) of scope.row.answerList" :key="aIndex">
                <div class="choice-img" v-if="a.length > 5">
                  <img :src="a" class=""/>
                </div>
                <span v-else style="margin-right: 4px;">{{ a }}</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column label="答题状态" prop="quizIng" width="90">
          <template slot-scope="scope">
            <el-tag :type="scope.row.quizIng === 0 ? 'info' : scope.row.quizIng === 1 ? '' : 'success'" size="mini">
              {{ scope.row.quizIng === 0 ? '未作答' : scope.row.quizIng === 1 ? '作答中' : '作答完成' }}
            </el-tag>
          </template>
        </el-table-column> -->
        <!-- <el-table-column label="是否作废" prop="quizIng" width="90">
          <template slot-scope="scope">
            <el-tag :type="scope.row.isDiscard === 0 ? 'success' : 'danger'" size="mini">
              {{ scope.row.isDiscard === 0 ? '正常' : '作废' }}
            </el-tag>
          </template>
        </el-table-column> -->
        <el-table-column label="选项" prop="choice" width="180">
          <template slot-scope="scope">
            <template v-if="scope.row.choiceType === 2">
              <span class="choice-text" v-for="(font, index) of scope.row.choiceList" :key="index">{{ font }}</span>
            </template>
            <template v-else>
              <div class="choice-img" v-for="(img, index) of scope.row.choiceList" :key="index">
                <img :src="img" alt="">
              </div>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <!-- 录音播放 -->
  </div>
</template>
<script>
export default {
  data () {
    return {
      dataList: [],
      total: 0,
      queryForm: {
        pageNum: 1,
        pageSize: 20,
        activityType: '',
        season: '',
        isGroup: '',
        nationalFormId: ''
      },
      type: '',
      typeStr: '',
      playing: false,
      formName: '',
      editVisible: false
    }
  },
  created () {
    this.queryForm.nationalFormId = this.$route.query.id
    this.queryForm.isGroup = this.$route.query.isGroup
    this.queryForm.season = this.$route.query.season
    this.queryForm.activityType = this.$route.query.activityType
    this.formName = this.$route.query.paper
    this.type = Number(this.$route.query.type)
    this.typeStr = this.type === 1 ? '表单答题' : this.type === 2 ? '总决选现场答题' : '练习题'
    this.getList()
  },
  methods: {
    rowClass ({ row, rowIndex }) {
      return row.isStandby ? 'isStandby' : ''
    },
    goBack () {
      this.$router.push(`/academic_Management/paper?type=${this.type}`)
    },
    getList () {
      const url = 'national/queryNationalGroupForm'
      this.$http.get(url, { params: this.queryForm }).then(res => {
        if (res.code === 200) {
          this.total = res.data.total
          this.dataList = res.data
          this.dataList.forEach(item => {
            // 选项
            if (item.choice.includes('http')) {
              item.choiceType = 1
            } else {
              item.choiceType = 2
            }
            item.choiceList = item.choice.split(',')
            // 答案
            item.answerList = item.answer.split(',')
          })
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
.choice-text{
  display: block;
  float: left;
  min-width: 20px;
  height: 24px;
  text-align: center;
  line-height: 24px;
  margin: 4px;
  border: 1px solid #409EFF;
  border-radius: 4px;
  font-size: 14px;
  color: #000;
  padding-left: 2px;
  padding-right: 2px;
}
.choice-img{
  width: 32px;
  height: 32px;
  padding-top: 1px;
  margin-right: 8px;
  border: 1px solid #409EFF;
  border-radius: 4px;
  text-align: center;
  display: inline-block;
  img{
    height: 28px;
    width: auto;
  }
}
.refresh{
  color: #409EFF;
  cursor: pointer;
  margin-left: 12px;
}
.play-audio{
  width: 40px;
  height: 40px;
  border-radius: 100%;
  padding: 0;
}
.title{
  margin-bottom: 24px;
  border-bottom: 1px solid #DCDFE6;
  padding-bottom: 8px;
}
.tip-text{
  font-size: 12px;
  color: #999;
  line-height: 22px;
}
.formName{
  color: #409EFF;
  font-weight: bold;
  font-size: 18px;
  margin-right: 4px;
}
</style>
